<div class="dp-wrapper" [class.dp-disabled]="disabled">
  @if (label) {
    <label class="dp-label" [for]="inputId">
      {{ label }}
      @if (required) {
        <span class="dp-required">*</span>
      }
    </label>
  }

  <!-- Input + calendar icon -->
  <div
    class="dp-field"
    [class.dp-field-open]="isOpen()"
    [class.dp-field-error]="hasError"
    [class.dp-field-disabled]="disabled"
  >
    <input
      class="dp-input"
      type="text"
      [id]="inputId"
      [placeholder]="datePlaceholder()"
      [disabled]="disabled"
      [value]="inputText"
      (input)="onInputChange($event)"
      (keydown)="onInputKeyDown($event)"
      (paste)="onInputPaste($event)"
      (blur)="onInputBlur()"
      (click)="$event.stopPropagation()"
      autocomplete="off"
      [attr.aria-label]="label || datePlaceholder()"
      [attr.aria-required]="required"
      [attr.aria-invalid]="hasError"
      [attr.aria-expanded]="isOpen()"
    />
    <button
      type="button"
      class="dp-toggle-btn"
      [disabled]="disabled"
      (click)="openCalendar($event)"
      [attr.aria-label]="isOpen() ? 'Takvimi kapat' : 'Takvimi aç'"
    >
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="14" height="13" rx="2" stroke="currentColor" stroke-width="1.5"/>
        <path d="M3 8h14" stroke="currentColor" stroke-width="1.5"/>
        <path d="M7 2v3M13 2v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </button>
  </div>

  @if (hasError && errorText) {
    <span class="dp-error-text" role="alert">{{ errorText }}</span>
  }
</div>

<!-- Fixed-position panel: renders outside any overflow:hidden ancestor -->
@if (isOpen()) {
  <div
    class="dp-panel"
    [class.dp-panel--above]="panelAbove()"
    [style.top]="panelStyle().top"
    [style.left]="panelStyle().left"
    role="dialog"
    aria-modal="true"
    tabindex="-1"
    (mousedown)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
  >
    <div class="dp-header">
      <button
        class="dp-nav-btn"
        type="button"
        (click)="prevHeader($event)"
        [attr.aria-label]="calendarView() === 'days' ? 'Önceki ay' : calendarView() === 'months' ? 'Önceki yıl' : 'Önceki yıllar'"
      >
        <svg viewBox="0 0 20 20" fill="none"><path d="M12 15l-5-5 5-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>

      <div class="dp-title-group">
        @if (calendarView() === 'days') {
          <button type="button" class="dp-title-btn" (click)="showMonthPicker($event)">
            {{ MONTHS[viewMonth()] }}
          </button>
          <button type="button" class="dp-title-btn" (click)="showYearPicker($event)">
            {{ viewYear() }}
          </button>
        } @else if (calendarView() === 'months') {
          <button type="button" class="dp-title-btn dp-title-btn--single" (click)="showYearPicker($event)">
            {{ viewYear() }}
          </button>
        } @else {
          <span class="dp-title">{{ yearPageLabel() }}</span>
        }
      </div>

      <button
        class="dp-nav-btn"
        type="button"
        (click)="nextHeader($event)"
        [attr.aria-label]="calendarView() === 'days' ? 'Sonraki ay' : calendarView() === 'months' ? 'Sonraki yıl' : 'Sonraki yıllar'"
      >
        <svg viewBox="0 0 20 20" fill="none"><path d="M8 5l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </button>
    </div>

    @if (calendarView() === 'days') {
      <div class="dp-weekdays">
        @for (wd of WEEKDAYS; track wd) {
          <div class="dp-weekday">{{ wd }}</div>
        }
      </div>

      <div class="dp-grid">
        @for (cell of calendarDays(); track $index) {
          <button
            type="button"
            class="dp-cell"
            [class.dp-cell-other]="!cell.current"
            [class.dp-cell-today]="cell.current && isToday(cell.date)"
            [class.dp-cell-selected]="isSelected(cell.date)"
            (click)="selectDay($event, cell.date)"
            [attr.aria-label]="cell.date.toLocaleDateString('tr-TR')"
            [attr.aria-pressed]="isSelected(cell.date)"
          >
            {{ cell.date.getDate() }}
          </button>
        }
      </div>
    } @else if (calendarView() === 'months') {
      <div class="dp-picker-grid dp-picker-grid--months">
        @for (month of MONTHS; track $index) {
          <button
            type="button"
            class="dp-picker-cell"
            [class.dp-picker-cell-selected]="viewMonth() === $index"
            (click)="selectMonth($event, $index)"
            [attr.aria-label]="month"
            [attr.aria-pressed]="viewMonth() === $index"
          >
            {{ month.slice(0, 3) }}
          </button>
        }
      </div>
    } @else {
      <div class="dp-picker-grid dp-picker-grid--years">
        @for (year of yearPageYears(); track year) {
          <button
            type="button"
            class="dp-picker-cell"
            [class.dp-picker-cell-selected]="viewYear() === year"
            (click)="selectYear($event, year)"
            [attr.aria-label]="year.toString()"
            [attr.aria-pressed]="viewYear() === year"
          >
            {{ year }}
          </button>
        }
      </div>
    }
  </div>
}
